var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button", "aria-label": "Close" },
          on: {
            click: function ($event) {
              return _vm.modal.dismiss()
            },
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "modal-title flex-around-center" }, [
        _c("div", { staticClass: "flex-column flex-center-start" }, [
          _c("span", { staticClass: "display-2" }, [
            _vm._v("Paiement terminé"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "display-6" }, [
            _vm._v(
              _vm._s(_vm.order.shop.DefaultName) +
                " - " +
                _vm._s(_vm.order.shop.City)
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-column flex-center-center" }, [
          _vm.order.Table
            ? _c("span", { staticClass: "display-4" }, [
                _vm._v("Table " + _vm._s(_vm.order.Table)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "display-6" }, [
            _vm._v("Ticket nº" + _vm._s(_vm.order.TicketId)),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("form", [
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          _c("h2", { staticClass: "text-center" }, [
            _vm._v(
              "Montant total " + _vm._s(_vm.ShopService.prix(_vm.order.Total))
            ),
          ]),
          _vm._v(" "),
          _c("OrderSummaryMiniCopy", { attrs: { order: _vm.order } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }, [
        _c(
          "button",
          {
            staticClass: "btnFlat-color1 w-100",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$emit("go")
              },
            },
          },
          [_vm._v("Terminé")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-header" }, [
        _c("h3", { staticClass: "modal-title text-center" }, [
          _vm._v("Merci d'avoir commandé chez"),
        ]),
        _vm._v(" "),
        _c("h3", { staticClass: "modal-title text-center" }, [
          _vm._v(" " + _vm._s(_vm.order.shop.DefaultName)),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }